import React from 'react';
import { API_ROOT } from '../../../../core/duck';
import Box from '../../../../components/Box';
import Spinner from '../../../../components/Spinner';
import CheckMark from '../../../../components/CheckMark';


class Reset extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isFetching: true,
      validToken: true,
      passwordIsValid: null,
      repeatIsValid: null,
      done: false,
      password: '',
      repeatPassword: '',
      errorMessage: null
    };

    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleRepeatChange = this.handleRepeatChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { params: { uid, token } } = this.props;

    fetch(`${API_ROOT}/v1/users/reset/${uid}/${token}/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(json => {
        this.setState({isFetching: false});
        if (json.token) {
          this.setState({validToken: false});
        }
      });
  }

  handlePasswordChange(e) {
    const { repeatPassword } = this.state;
    const password = e.target.value;
    const passwordIsValid = (password.length >= 8);
    const repeatIsValid = Reset.repeatIsValid(password, repeatPassword, passwordIsValid);
    this.setState({password, passwordIsValid, repeatIsValid, errorMessage: null});
  }

  handleRepeatChange(e) {
    const { password, passwordIsValid } = this.state;
    const repeatPassword = e.target.value;
    const repeatIsValid = Reset.repeatIsValid(password, repeatPassword, passwordIsValid);
    this.setState({repeatPassword, repeatIsValid});
  }

  static repeatIsValid(password, repeatPassword, passwordIsValid) {
    return (repeatPassword.length && passwordIsValid) ? (password === repeatPassword) : null;
  }

  handleSubmit(e) {
    const { password, repeatPassword, passwordIsValid, repeatIsValid } = this.state;
    const { params: { uid, token } } = this.props;

    e.preventDefault();

    if (passwordIsValid && repeatIsValid) {
      this.setState({isFetching: true, errorMessage: null});

      fetch(`${API_ROOT}/v1/users/reset/${uid}/${token}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          password,
          password_confirm: repeatPassword
        })
      })
        .then(response => response.json())
        .then(json => {
          if (json.status === 'ok') {
            this.setState({isFetching: false, done: true});
          } else {
            if (json.password) {
              const errorMessage = json.password[0];
              this.setState({isFetching: false, passwordIsValid: false, errorMessage});
            }
          }
        });
    }
  }

  render() {
    const { isFetching, validToken, done, password, repeatPassword, passwordIsValid, repeatIsValid, errorMessage } = this.state;

    return (
      <div className="row" style={{marginTop: '10px'}}>
        <div className="col-xs-6 col-xs-offset-3">
          {!validToken &&
          <Box title="Reset Password">
            <CheckMark size={40} message="Invalid reset link!" error={true}/>
          </Box>
          }
          {validToken && done &&
          <Box title="Reset Password">
            <CheckMark size={40} message="Password changed!"/>
            <p style={{textAlign: 'center'}}>You can now log in with your new password.</p>
          </Box>
          }
          {validToken && !done &&
          <form role="form" onSubmit={this.handleSubmit}>
            {isFetching && <Spinner/>}
            <Box title="Reset Password"
                 footer={<button className={"btn btn-default" + ((!isFetching && passwordIsValid && repeatIsValid) ? '' : ' disabled')}>Submit</button>}>
              <div className={`form-group ${passwordIsValid === false ? 'has-error' : ''}`}>
                <input type="password" className="form-control" placeholder="Enter new password" value={password} onChange={this.handlePasswordChange}/>
                <span className="help-block">{errorMessage || 'At least 8 characters.'}</span>
              </div>
              <div className={`form-group ${repeatIsValid === false ? 'has-error' : ''}`}>
                <input type="password" className="form-control" placeholder="Repeat new password" value={repeatPassword} onChange={this.handleRepeatChange}/>
                {(repeatIsValid === false) &&
                <span className="help-block">Passwords don't match.</span>
                }
              </div>
            </Box>
          </form>
          }
        </div>
        {/* /.col */}
      </div>
    );
  }
}

export default Reset;



// WEBPACK FOOTER //
// ./src/features/auth/components/Reset/Reset.js